import React from 'react';
import { CloseIcon } from 'assets/icons';
import { Button } from 'components';
import { Globals } from 'utils';
import { BannerService } from 'services';

interface ModalDeleteBannerProps {
  banner?: any
  onClose: (reload?: boolean) => void
}

export const ModalDeleteBanner = ({ banner, onClose }: ModalDeleteBannerProps) => {

  const onSubmit = async () => {
    try {
      await BannerService.delete({ banner_id: banner.id });
      onClose(true);
      Globals.showSuccess('Banner eliminado');

    } catch (error) {
      Globals.showError('Ocurrió un error inesperado');
    }
  }

  return (
    <div>
      <header>
        <p className="title">Confirmar</p>
        <button className="close-btn" onClick={() => onClose()}>
          <img src={CloseIcon} alt="Cerrar" />
        </button>
      </header>

      <p className="message">¿Está seguro de que desea eliminar este banner?</p>
      <div className="actions">
        <Button onClick={() => onClose()} clear>Cancelar</Button>
        <Button onClick={onSubmit}>Aceptar</Button>
      </div>
    </div>
  );
}